// extracted by mini-css-extract-plugin
export default {"layout":"_WWl_","layout__content":"wEmsq","layout__logo-wrapper":"Ot3zf","layout__logoWrapper":"Ot3zf","appear-from-above":"TDBbD","appearFromAbove":"TDBbD"};